(function () {
  var SECTION_SELECTOR = '.oddit-header';

  function initSection(header) {
    if (!header) return;

    var menuToggle = header.querySelector('.oddit-header__menu-toggle');
    var mobileMenu = header.querySelector('.oddit-header__mobile-menu');
    var mobileOverlay = header.querySelector('[data-mobile-menu-overlay]');
    var mobileClose = header.querySelector('[data-mobile-menu-close]');

    /* Country/currency selector: native <select> overlaid on the trigger;
       submit the localization form on change. */
    var currencySelect = header.querySelector('[data-currency-select]');
    if (currencySelect) {
      currencySelect.addEventListener('change', function () {
        if (currencySelect.form) currencySelect.form.submit();
      });
    }
    var megaMenu = header.querySelector('[data-mega-menu-panel]');
    var megaOverlay = header.querySelector('[data-mega-menu-overlay]');
    var megaTriggers = header.querySelectorAll('[data-mega-menu-trigger]');
    var primaryLinks = header.querySelector('.oddit-header__primary-links');
    var activeTrigger = null;

    /* Show a right-edge drop shadow on the primary nav when it has scrollable
       overflow and the user hasn't scrolled to the end yet. */
    if (primaryLinks) {
      var updatePrimaryLinksShadow = function () {
        var hasOverflow = primaryLinks.scrollWidth > primaryLinks.clientWidth + 1;
        var atEnd = primaryLinks.scrollLeft + primaryLinks.clientWidth >= primaryLinks.scrollWidth - 1;
        primaryLinks.classList.toggle('is-scrollable-end', hasOverflow && !atEnd);
      };
      updatePrimaryLinksShadow();
      primaryLinks.addEventListener('scroll', updatePrimaryLinksShadow, { passive: true });
      window.addEventListener('resize', updatePrimaryLinksShadow);
      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(updatePrimaryLinksShadow);
        ro.observe(primaryLinks);
      }
    }

    function openMobileMenu() {
      if (!mobileMenu) return;
      /* Anchor the menu's top to the header's actual bottom edge in pixels,
         and explicitly size the height to the remaining viewport. Avoids any
         CSS calc/var indirection so the layout is correct even when the
         viewport is shorter than the menu's content. */
      var headerBottom = Math.max(0, header.getBoundingClientRect().bottom);
      mobileMenu.style.top = headerBottom + 'px';
      mobileMenu.style.height = 'calc(100dvh - ' + headerBottom + 'px)';

      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      menuToggle.setAttribute('aria-expanded', 'true');
      menuToggle.setAttribute('aria-label', 'Close menu');
      document.body.classList.add('oddit-header-menu-open');

      /* Reset the inner panel + any open submenu to scrollTop 0 so the
         promo banner at the top is visible on every open. Reset
         synchronously, on the next frame, and again after the slide
         transition finishes — this clobbers any browser auto-scroll
         (e.g. scroll-into-view from focus changes, iOS layout shifts). */
      var panel = mobileMenu.querySelector('.oddit-header__mobile-menu-panel');
      if (panel) {
        panel.scrollTop = 0;
        requestAnimationFrame(function () {
          panel.scrollTop = 0;
        });
        var resetAfterTransition = function () {
          panel.scrollTop = 0;
          mobileMenu.removeEventListener('transitionend', resetAfterTransition);
        };
        mobileMenu.addEventListener('transitionend', resetAfterTransition);
      }
      var submenus = mobileMenu.querySelectorAll('.oddit-header__mobile-submenu');
      for (var s = 0; s < submenus.length; s++) {
        submenus[s].scrollTop = 0;
      }
    }

    function closeMobileMenu() {
      if (!mobileMenu) return;
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', 'Open menu');
      document.body.classList.remove('oddit-header-menu-open');
      mobileMenu.style.top = '';
      mobileMenu.style.height = '';
    }

    function openMegaMenu(triggerLabel) {
      if (!megaMenu) return;

      var panels = megaMenu.querySelectorAll('[data-mega-menu-label]');
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-mega-menu-label') === triggerLabel) {
          panels[i].style.display = '';
        } else {
          panels[i].style.display = 'none';
        }
      }

      megaMenu.classList.add('is-open');
      megaMenu.setAttribute('aria-hidden', 'false');

      if (megaOverlay) {
        megaOverlay.classList.add('is-visible');
      }
    }

    function closeMegaMenu() {
      if (!megaMenu) return;

      megaMenu.classList.remove('is-open');
      megaMenu.setAttribute('aria-hidden', 'true');

      if (megaOverlay) {
        megaOverlay.classList.remove('is-visible');
      }

      for (var i = 0; i < megaTriggers.length; i++) {
        megaTriggers[i].setAttribute('aria-expanded', 'false');
      }

      activeTrigger = null;
    }

    if (menuToggle) {
      menuToggle.addEventListener('click', function () {
        var isOpen = mobileMenu && mobileMenu.classList.contains('is-open');
        if (isOpen) {
          closeMobileMenu();
        } else {
          openMobileMenu();
        }
      });
    }

    if (mobileOverlay) {
      mobileOverlay.addEventListener('click', closeMobileMenu);
    }

    if (mobileClose) {
      mobileClose.addEventListener('click', closeMobileMenu);
    }

    var submenuTriggers = header.querySelectorAll('[data-mobile-submenu-trigger]');
    for (var s = 0; s < submenuTriggers.length; s++) {
      (function (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          var targetId = trigger.getAttribute('data-submenu-target');
          if (!targetId) return;
          var submenu = header.querySelector('[data-submenu-id="' + targetId + '"]');
          if (!submenu) return;
          trigger.setAttribute('aria-expanded', 'true');
          submenu.classList.add('is-active');
          submenu.setAttribute('aria-hidden', 'false');
        });
      })(submenuTriggers[s]);
    }

    var submenuClosers = header.querySelectorAll('[data-mobile-submenu-close]');
    for (var c = 0; c < submenuClosers.length; c++) {
      (function (closer) {
        closer.addEventListener('click', function (e) {
          e.preventDefault();
          var submenu = closer.closest('[data-mobile-submenu]');
          if (!submenu) return;
          submenu.classList.remove('is-active');
          submenu.setAttribute('aria-hidden', 'true');
          var targetId = submenu.getAttribute('data-submenu-id');
          if (targetId) {
            var trigger = header.querySelector('[data-submenu-target="' + targetId + '"]');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
          }
        });
      })(submenuClosers[c]);
    }

    var megaCloseTimer = null;

    /* Touch devices fire a synthetic mouseenter on first tap (sticky hover),
       which would open the menu, then the immediate click handler toggles it
       closed — requiring a second tap to reopen. Restrict hover-driven open/close
       to devices that actually support hovering. */
    var supportsHover = !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function openMegaMenuFor(trigger) {
      clearTimeout(megaCloseTimer);
      var label = trigger.getAttribute('data-mega-menu-label');
      for (var j = 0; j < megaTriggers.length; j++) {
        megaTriggers[j].setAttribute('aria-expanded', 'false');
      }
      trigger.setAttribute('aria-expanded', 'true');
      activeTrigger = trigger;
      openMegaMenu(label);
    }

    function scheduleCloseMegaMenu() {
      clearTimeout(megaCloseTimer);
      megaCloseTimer = setTimeout(function () {
        closeMegaMenu();
      }, 180);
    }

    for (var t = 0; t < megaTriggers.length; t++) {
      (function (trigger) {
        var wrapper = trigger.closest('.oddit-header__link-wrapper') || trigger.parentElement;

        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          var isCurrentlyOpen = trigger.getAttribute('aria-expanded') === 'true';
          if (isCurrentlyOpen) {
            closeMegaMenu();
          } else {
            openMegaMenuFor(trigger);
          }
        });

        if (wrapper && supportsHover) {
          wrapper.addEventListener('mouseenter', function () {
            openMegaMenuFor(trigger);
          });
          wrapper.addEventListener('mouseleave', function () {
            scheduleCloseMegaMenu();
          });
        }
      })(megaTriggers[t]);
    }

    if (megaMenu && supportsHover) {
      megaMenu.addEventListener('mouseenter', function () {
        clearTimeout(megaCloseTimer);
      });
      megaMenu.addEventListener('mouseleave', scheduleCloseMegaMenu);
    }

    if (megaOverlay) {
      megaOverlay.addEventListener('click', closeMegaMenu);
    }

    var dropdownTriggers = header.querySelectorAll('[data-dropdown-trigger]');
    var dropdowns = header.querySelectorAll('[data-dropdown]');
    var dropdownCloseTimers = {};

    function closeAllDropdowns() {
      for (var i = 0; i < dropdowns.length; i++) {
        dropdowns[i].classList.remove('is-open');
        dropdowns[i].setAttribute('aria-hidden', 'true');
      }
      for (var j = 0; j < dropdownTriggers.length; j++) {
        dropdownTriggers[j].setAttribute('aria-expanded', 'false');
      }
    }

    function openDropdown(targetId, trigger, dropdown) {
      clearTimeout(dropdownCloseTimers[targetId]);
      for (var i = 0; i < dropdowns.length; i++) {
        if (dropdowns[i] !== dropdown) {
          dropdowns[i].classList.remove('is-open');
          dropdowns[i].setAttribute('aria-hidden', 'true');
        }
      }
      for (var j = 0; j < dropdownTriggers.length; j++) {
        if (dropdownTriggers[j] !== trigger) {
          dropdownTriggers[j].setAttribute('aria-expanded', 'false');
        }
      }
      dropdown.classList.add('is-open');
      dropdown.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function scheduleCloseDropdown(targetId, trigger, dropdown) {
      clearTimeout(dropdownCloseTimers[targetId]);
      dropdownCloseTimers[targetId] = setTimeout(function () {
        dropdown.classList.remove('is-open');
        dropdown.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
      }, 180);
    }

    for (var d = 0; d < dropdownTriggers.length; d++) {
      (function (trigger) {
        var targetId = trigger.getAttribute('data-dropdown-target');
        if (!targetId) return;
        var dropdown = header.querySelector('[data-dropdown="' + targetId + '"]');
        if (!dropdown) return;
        var wrapper = trigger.closest('.oddit-header__link-wrapper') || trigger.parentElement;

        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var willOpen = !dropdown.classList.contains('is-open');
          closeAllDropdowns();
          if (willOpen) openDropdown(targetId, trigger, dropdown);
        });

        if (wrapper && supportsHover) {
          wrapper.addEventListener('mouseenter', function () {
            openDropdown(targetId, trigger, dropdown);
          });
          wrapper.addEventListener('mouseleave', function () {
            scheduleCloseDropdown(targetId, trigger, dropdown);
          });
        }

        if (supportsHover) {
          dropdown.addEventListener('mouseenter', function () {
            clearTimeout(dropdownCloseTimers[targetId]);
          });
          dropdown.addEventListener('mouseleave', function (e) {
            if (wrapper && wrapper.contains(e.relatedTarget)) return;
            scheduleCloseDropdown(targetId, trigger, dropdown);
          });
        }
      })(dropdownTriggers[d]);
    }

    document.addEventListener('click', function (e) {
      if (
        !e.target.closest('[data-dropdown-trigger]') &&
        !e.target.closest('[data-dropdown]')
      ) {
        closeAllDropdowns();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (mobileMenu && mobileMenu.classList.contains('is-open')) {
          closeMobileMenu();
          if (menuToggle) menuToggle.focus();
        }
        if (megaMenu && megaMenu.classList.contains('is-open')) {
          closeMegaMenu();
          if (activeTrigger) activeTrigger.focus();
        }
        closeAllDropdowns();
      }
    });

    /* ── Cart Drawer Toggle ── */
    var cartToggles = header.querySelectorAll('[data-cart-toggle]');
    for (var i = 0; i < cartToggles.length; i++) {
      cartToggles[i].addEventListener('click', function () {
        if (window.OdditCartDrawer) {
          window.OdditCartDrawer.open();
        }
      });
    }

    /* ── Search Drawer Toggle ── */
    var searchToggles = header.querySelectorAll('[data-search-toggle]');
    for (var i = 0; i < searchToggles.length; i++) {
      searchToggles[i].addEventListener('click', function () {
        if (window.OdditSearchDrawer) {
          window.OdditSearchDrawer.toggle();
        }
      });
    }

    /* ── Desktop Search Input → Open Search Drawer on Focus ── */
    var desktopSearchInput = header.querySelector('.oddit-header__search-input');
    if (desktopSearchInput) {
      desktopSearchInput.addEventListener('focus', function () {
        if (window.OdditSearchDrawer) {
          window.OdditSearchDrawer.open();
          this.blur();
        }
      });
    }
  }

  /* ── Cart Count Badge — listen for cart:updated globally ──
     Mirror the cart drawer's "visible" count by excluding line items flagged
     as `_child_product` (engraving + bolt/clip add-ons that roll up into a
     parent line). Falls back to the raw item_count if the cart payload is
     missing items. */
  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail.cart;
    var count = 0;
    if (cart && Array.isArray(cart.items)) {
      for (var k = 0; k < cart.items.length; k++) {
        var item = cart.items[k];
        if (item && item.properties && item.properties._child_product) continue;
        count += (item && item.quantity) || 0;
      }
    } else if (cart && typeof cart.item_count === 'number') {
      count = cart.item_count;
    }
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      badges[i].style.display = count > 0 ? '' : 'none';
    }
  });

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();